// extracted by mini-css-extract-plugin
export var skipLink = "gs_x0";